import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

// Subscription Components
import SubscriptionPlansPage from '../pages/subscription/SubscriptionPlansPage';
import MyBusinessPage from '../pages/subscription/MyBusinessPage';
import PaymentPendingPage from '../pages/subscription/PaymentPendingPage';
import PaymentSuccessPage from '../pages/subscription/PaymentSuccessPage';
// import PaymentHistoryPage from '../pages/subscription/PaymentHistoryPage';

const SubscriptionRoutes = () => {
  return (
    <Routes>
      {/* Subscription Plans */}
      <Route 
        path="/payment/pending" 
        element={
          <PermissionRoute requiredPermission="view_subscription">
            <PaymentPendingPage />
          </PermissionRoute>
        } 
      />

      {/* Payment success */}
      <Route 
        path="/payment/success" 
        element={
          <PermissionRoute requiredPermission="view_subscription">
            <PaymentSuccessPage />
          </PermissionRoute>
        } 
      />

      {/* Payment pending */}
      <Route 
        path="/plans" 
        element={
          <PermissionRoute requiredPermission="view_subscription">
            <SubscriptionPlansPage />
          </PermissionRoute>
        } 
      />
      
      {/* Current Subscription */}
      <Route 
        path="/" 
        element={
          <PermissionRoute requiredPermission="view_subscription">
            <MyBusinessPage />
          </PermissionRoute>
        } 
      />
      
      {/* Payment History */}
      {/* <Route 
        path="/payments" 
        element={
          <PermissionRoute requiredPermission="view_subscription">
            <PaymentHistoryPage />
          </PermissionRoute>
        } 
      /> */}
    </Routes>
  );
};

export default SubscriptionRoutes;